import { render, staticRenderFns } from "./DataOrNA.vue?vue&type=template&id=36c8a098&scoped=true"
import script from "./DataOrNA.vue?vue&type=script&lang=js"
export * from "./DataOrNA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c8a098",
  null
  
)

export default component.exports